import { Slot } from '@radix-ui/react-slot';
import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib/cn';
import { Spinner } from '../spinner';
import { type ButtonVariants, buttonVariants } from './button-variants';

type ButtonProps = ComponentProps<'button'> &
  ButtonVariants & {
    asChild?: boolean;
    isLoading?: boolean;
  };

export function Button({
  asChild = false,
  isLoading = false,
  variant,
  size,
  isBlock,
  className,
  children,
  disabled,
  type = 'button',
  ...props
}: ButtonProps) {
  const classes = cn(buttonVariants({ variant, size, isBlock }), className);
  if (asChild) {
    return (
      <Slot data-slot="button" className={classes} {...props}>
        {children}
      </Slot>
    );
  }
  return (
    <button
      data-slot="button"
      type={type}
      className={classes}
      disabled={disabled || isLoading}
      aria-busy={isLoading || undefined}
      {...props}
    >
      {isLoading ? <Spinner /> : null}
      {children}
    </button>
  );
}
